export default __webpack_public_path__ + "static/media/bg2_novo.62c02eb3.png";